'use strict';

angular.module('oddCampaignRespondentModule', [
]);